import React from 'react';

import { getIcon, SvgPathProps } from './Icon';

const Undo: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path
      fillRule={'evenodd'}
      d="M37.976 24.195c0 7.782-6.331 14.112-14.113 14.112-6.675 0-12.49-4.74-13.825-11.27l1.273-.26c1.213 5.928 6.492 10.23 12.552 10.23 7.065 0 12.813-5.747 12.813-12.812 0-7.065-5.748-12.813-12.813-12.813-3.885 0-7.554 1.796-9.977 4.812h4.92v1.299H11.97l-.337-7.12 1.299-.061.223 4.72c2.669-3.11 6.578-4.95 10.707-4.95 7.782 0 14.113 6.33 14.113 14.113"
    />
  );

  const normalHover = (
    <path
      fillRule={'evenodd'}
      d="M34.02 34.213a14.132 14.132 0 01-10.002 4.125 14.03 14.03 0 01-7.743-2.317l.716-1.085c5.049 3.333 11.823 2.644 16.11-1.642 4.995-4.996 4.995-13.124 0-18.12-4.996-4.995-13.124-4.994-18.12 0-2.747 2.747-4.071 6.611-3.653 10.457l3.479-3.479.919.92-4.833 4.832-5.272-4.796.875-.962 3.496 3.181c-.313-4.087 1.15-8.153 4.07-11.072 5.502-5.502 14.455-5.503 19.958 0 5.502 5.502 5.502 14.456 0 19.958"
    />
  );

  const xSmall = (
    <path
      fillRule={'evenodd'}
      d="M38.21 24.195c0 7.911-6.436 14.347-14.347 14.347-6.784 0-12.696-4.82-14.055-11.457l1.732-.355c1.192 5.82 6.374 10.043 12.323 10.043 6.936 0 12.579-5.642 12.579-12.578 0-6.936-5.643-12.579-12.579-12.579-3.65 0-7.109 1.61-9.486 4.342h4.428v1.77h-7.058l-.346-7.343 1.766-.085.195 4.13a14.384 14.384 0 0110.501-4.582c7.911 0 14.347 6.436 14.347 14.347"
    />
  );

  const xSmallHover = (
    <path
      fillRule={'evenodd'}
      d="M34.186 34.38a14.37 14.37 0 01-10.169 4.192c-2.73 0-5.474-.772-7.87-2.355l.973-1.475c4.957 3.271 11.608 2.593 15.815-1.613 4.905-4.905 4.905-12.885 0-17.788-4.903-4.905-12.884-4.905-17.788 0-2.581 2.58-3.888 6.165-3.637 9.777l3.13-3.132 1.251 1.252-4.99 4.99-5.438-4.947 1.19-1.307 3.058 2.781a14.382 14.382 0 014.186-10.665c5.593-5.593 14.695-5.594 20.289 0 5.593 5.594 5.593 14.695 0 20.29"
    />
  );

  const xxSmall = (
    <path
      fillRule={'evenodd'}
      d="M38.726 24.194c0 8.196-6.668 14.864-14.864 14.864-7.028 0-13.152-4.992-14.56-11.87l2.744-.56c1.14 5.578 6.11 9.628 11.816 9.628 6.652 0 12.064-5.41 12.064-12.062 0-6.652-5.412-12.062-12.064-12.062-3.1 0-6.05 1.218-8.272 3.312h5.248v2.802h-9.516l-.004-9.89h2.802v4.624a14.893 14.893 0 0 1 9.742-3.648c8.196 0 14.864 6.666 14.864 14.862"
    ></path>
  );

  const xxSmallHover = (
    <path
      fillRule={'evenodd'}
      d="M32.733 36.266a14.834 14.834 0 0 1-8.726 2.824 14.835 14.835 0 0 1-10.028-3.876l1.89-2.066c4.198 3.844 10.6 4.204 15.22.852 5.382-3.906 6.584-11.464 2.678-16.848a11.986 11.986 0 0 0-7.87-4.826c-3.184-.51-6.37.258-8.978 2.15-2.51 1.822-4.184 4.54-4.75 7.54l4.248-3.082 1.644 2.266-7.702 5.59-5.812-8.002 2.266-1.646 2.718 3.744a14.89 14.89 0 0 1 5.744-8.676c6.63-4.816 15.944-3.336 20.756 3.298 4.814 6.634 3.334 15.944-3.298 20.758"
    ></path>
  );

  return getIcon({ size, isHovered, normal, normalHover, xSmall, xSmallHover, xxSmall, xxSmallHover });
};

export default Undo;
